"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var arcgis = __importStar(require("@conveyal/geocoder-arcgis-geojson"));
var pelias = __importStar(require("isomorphic-mapzen-search"));
var lodash_memoize_1 = __importDefault(require("lodash.memoize"));
var here = __importStar(require("./apis/here"));
var photon = __importStar(require("./apis/photon"));
var otp = __importStar(require("./apis/otp"));
var offline = __importStar(require("./apis/offline"));
var arcgis_1 = __importDefault(require("./geocoders/arcgis"));
var noapi_1 = __importDefault(require("./geocoders/noapi"));
var pelias_1 = __importDefault(require("./geocoders/pelias"));
var here_1 = __importDefault(require("./geocoders/here"));
var photon_1 = __importDefault(require("./geocoders/photon"));
var otp_1 = __importDefault(require("./geocoders/otp"));
var offline_1 = __importDefault(require("./geocoders/offline"));
// Create a memoized getter to avoid recreating new geocoders each time.
var getGeocoder = (0, lodash_memoize_1.default)(function (geocoderConfig) {
    if (!geocoderConfig || !geocoderConfig.type) {
        return new noapi_1.default();
    }
    var type = geocoderConfig.type;
    switch (type) {
        case "ARCGIS":
            return new arcgis_1.default(arcgis, geocoderConfig);
        case "PELIAS":
            return new pelias_1.default(pelias, geocoderConfig);
        case "HERE":
            return new here_1.default(here, geocoderConfig);
        case "PHOTON":
            return new photon_1.default(photon, geocoderConfig);
        case "OTP":
            return new otp_1.default(otp, geocoderConfig);
        case "OFFLINE":
            return new offline_1.default(offline, geocoderConfig);
        default:
            console.error("Unknown geocoder type: \"".concat(type, "\". Using NoApiGeocoder."));
            return new noapi_1.default();
    }
});
exports.default = getGeocoder;
//# sourceMappingURL=index.js.map